import { render, staticRenderFns } from "./btn-square.vue?vue&type=template&id=4950f42c"
import script from "./btn-square.vue?vue&type=script&lang=js"
export * from "./btn-square.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports